import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import env from '../../config.json'

const API_KEY=env.GOOGLE_MAP_API_KEY;
const containerStyle = {
  width: "100%",
  height: "400px",
};

const center = {
  lat: 15.335, // Change to your desired latitude
  lng: 76.462, // Change to your desired longitude
};

const MapView = () => {
  console.log("Google Maps API Key:",API_KEY);
  return (
    <LoadScript googleMapsApiKey={API_KEY}>
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={10}>
        <Marker position={center} />
      </GoogleMap>
    </LoadScript>
  );
};

export default MapView;
